import _ from 'lodash';
import {
  log as makeLogHook,
  error_handler as makeErrorHandler,
  station_id as makeStationIdHandler,
} from '../hooks';

export default function configureHooks( app ) {

  const log = makeLogHook();
  const error_handler = makeErrorHandler();
  const station_id = makeStationIdHandler();

  app.hooks( {
    before  : {
      all     : [ station_id, log ],
      find    : [],
      get     : [],
      create  : [],
      update  : [],
      patch   : [],
      remove  : [],
    },

    after   : {
      all     : [ log ],
      find    : [],
      get     : [],
      create  : [],
      update  : [],
      patch   : [],
      remove  : [],
    },

    error   : {
      all     : [ log, error_handler ],
      find    : [],
      get     : [],
      create  : [],
      update  : [],
      patch   : [],
      remove  : [],
    },

  } );
}
